module.exports = __webpack_public_path__ + "static/media/student.4d73e121.svg";